import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhoneSlash = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 28.75,
	height: 23,
	viewBox: "0 0 28.75 23",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M28.74,22.2a.69.69,0,0,1-.14.53A.74.74,0,0,1,28,23a.71.71,0,0,1-.44-.15L.27,1.27a.72.72,0,0,1-.18-.21A.86.86,0,0,1,0,.79.63.63,0,0,1,0,.52.68.68,0,0,1,.15.26.92.92,0,0,1,.4.07L.49,0A.65.65,0,0,1,.68,0H.76a.61.61,0,0,1,.4.14L28.48,21.72a.65.65,0,0,1,.18.22A.61.61,0,0,1,28.74,22.2ZM17.39,17.54l1.16.92A19.85,19.85,0,0,1,5.89,23a2,2,0,0,1-2-1.62l-1-4.24a2,2,0,0,1,1.18-2.33h0l4.57-2a2.13,2.13,0,0,1,2.37.63l1.49,1.82c.38-.21.74-.47,1.11-.72l1.2.95a15.61,15.61,0,0,1-2.18,1.32.75.75,0,0,1-.88-.19L9.93,14.39a.6.6,0,0,0-.69-.18l-4.57,2a.6.6,0,0,0-.34.69l1,4.24a.59.59,0,0,0,.58.46A18.44,18.44,0,0,0,17.39,17.54ZM16.34,8.18a2,2,0,0,1-.57-2.38l2-4.57A2,2,0,0,1,20.05.05l4.24,1a2,2,0,0,1,1.59,2A19.82,19.82,0,0,1,22.44,14.2l-1.13-.89A18.48,18.48,0,0,0,24.44,3,.59.59,0,0,0,24,2.44l-4.24-1H19.6a.6.6,0,0,0-.55.36l-2,4.57a.6.6,0,0,0,.17.7l2.27,1.85a.73.73,0,0,1,.19.88c-.27.53-.57,1-.89,1.55l-1.16-.91c.17-.26.35-.5.5-.77Z",
		fill: "#fff"
	})]
});
const ForwardRef = forwardRef(SvgPhoneSlash);
export default ForwardRef;
